import { call, put, takeLatest } from "redux-saga/effects";
import { addNewWorkAuth, fetchWorkauths, updateWorkAuth } from "./workauthsApi";
import {
  getWorkauthsStart,
  getWorkauthsSuccess,
  getWorkauthsFailure,
  addNewWorkAuthStart,
  addNewWorkAuthSuccess,
  addNewWorkAuthFailure,
} from "./workauthsSlice";
import { showToast } from "../../../components";

function* fetchWorkauthsSaga(action) {
  try {
    console.log("Fetching workauths with params:", action.payload);
    const workauths = yield call(fetchWorkauths, action.payload);
    console.log("Workauths response:", workauths);
    yield put(getWorkauthsSuccess(workauths.data));
  } catch (error) {
    console.error("Workauths fetch error:", error);
    yield put(getWorkauthsFailure(error.message));
  }
}

function* addNewWorkAuthSaga(action) {
  try {
    const { submissionData,uiid,coll, onSuccess } = action.payload;
    let response 
    if(uiid){
      response= yield call(updateWorkAuth, coll,uiid,submissionData);
    }else{
      response= yield call(addNewWorkAuth, submissionData);
    }
    if (response.success) {
      if (onSuccess) {
        onSuccess(response.data);
      }
      yield put(addNewWorkAuthSuccess(response.data));
      // showToast("New Work Authorization Added", "success", 5000);
      // navigate("/employee/employee-profile");
    } else {
      yield put(addNewWorkAuthFailure(response.error));
      showToast("Failed to add work authorization", "error");
    }
  } catch (error) {
    yield put(addNewWorkAuthFailure(error.message));
    showToast("Error adding work authorization", "error", 5000);
  }
}

export function* watchFetchWorkauths() {
  yield takeLatest(getWorkauthsStart.type, fetchWorkauthsSaga);
  yield takeLatest(addNewWorkAuthStart.type, addNewWorkAuthSaga);
}
